import './polyfills/polyfill.objectFit';

import './vendor/bootstrap';

import headerDropdown from './components/header-dropdown';
import mobileMenu from './components/mobile-menu';
import logoSlider from './components/logo-slider';
import testimonialSlider from './components/testimonial-slider';
import blogSlider from './components/blog-slider';
import videoSlider from './components/video-slider';
import { formValidation } from './components/form';
import scrollLink from './components/scroll-link';
import tabSelect from './components/tab-select';
import record from './other/record';
import { lazyLoadImage, smoothScroll } from './other/custom_methods';

record();

window.addEventListener(
  'load',
  function () {
    headerDropdown();
    mobileMenu();
    logoSlider();
    blogSlider();
    videoSlider();
    testimonialSlider();
    formValidation();
    scrollLink();
    tabSelect();
    smoothScroll();
    lazyLoadImage();
  },
  false
);
